<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <MessageComponent v-if="$store.getters.messageModal"/>

        <v-alert :value="activeAlert" class="rounded-alert mx-3 py-2" icon="error" type="error">
            {{ activeAlertMsg }}
        </v-alert>
        <v-alert :value="isNplus2orKatataktiriosAlert" class="rounded-alert mx-3 py-2" icon="error" type="error">
            <div>{{ isNplus2orKatataktiriosAlertMsg }}</div>
        </v-alert>

        <v-alert :value="wronglyDeliveredAlert" class="rounded-alert mx-3 py-2" outline type="error">
            <div v-html="wronglyDeliveredAlertMsg"></div>
        </v-alert>

        <v-alert :value="dataEntryAllowedAlert" class="rounded-alert mx-3 py-2" outline type="info">
            <!--<div v-html="wronglyDeliveredAlertMsg"></div>-->
            <div> {{dataEntryAllowedAlertMsg}}</div>
        </v-alert>


        <v-container grid-list-md text-xs-center>

            <StudentCredentialsEdit :dialog="dialog" @changeCredentials="changeCredentials"
                                    @dialogClose="dialog = false"
                                    @dialogSave="dialog = false"></StudentCredentialsEdit>

            <InitializationComponent @changeCredentials="changeCredentials" v-if="$store.getters.initializationFlag"/>

            <v-layout justify-space-around row wrap>

                <v-flex class="md5" color="primary" xs6>
                    <v-expansion-panel class="elevation-6" expand v-model="StudentPanel">
                        <v-expansion-panel-content ripple>
                            <div slot="header">Στοιχεία Φοιτητή</div>
                            <v-card>
                                <v-card-text>
                                    <v-data-table
                                            :items="studentInfo"
                                            class="elevation-2"
                                            hide-actions
                                            hide-headers>
                                        <template slot="items" slot-scope="props">
                                            <td><b>{{ props.item.name }}</b></td>
                                            <td class="text-xs-left">{{ props.item.value }}</td>
                                        </template>
                                    </v-data-table>
                                </v-card-text>
                            </v-card>
                            <v-layout align-center fill-height justify-end pa-3 row>
                                <v-btn @click="dialog = true" color="info">Αλλαγή Στοιχείων Επικοινωνίας</v-btn>
                            </v-layout>

                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-flex>

                <v-flex class="md5" xs6>
                    <v-expansion-panel class="elevation-6" color="primary" expand focusable v-model="GeneralPanel">
                        <v-expansion-panel-content ripple>
                            <div slot="header">Γενικές Πληροφορίες</div>
                            <v-card>
                                <v-card-text>
                                    <v-data-table
                                            :items="generalInfo"
                                            class="elevation-2"
                                            hide-actions
                                            hide-headers>
                                        <template slot="items" slot-scope="props" v-if="!props.item.hasFlagBooks">
                                            <td><b>{{ props.item.name }}</b></td>
                                            <td class="text-xs-right">{{ props.item.value }}</td>
                                        </template>
                                    </v-data-table>
                                    <p class="ma-3">
                                        <a @click="openStudentEvaluation()">
                                            Έρευνα αποτίμησης της χρήσης των Συγγραμμάτων
                                        </a>
                                    </p>
                                    <p class="ma-3">

                                        <v-tooltip right>
                                            <a href=" https://twitter.com/eudoxusgr"
                                               slot="activator"
                                               target="_blank"><img alt="Μάθετε τα τελευταία νέα του Ευδόξου στο Twitter" :src="images.sample" height="20" width="20"></a>
                                            <span>Μάθετε τα τελευταία νέα του Ευδόξου στο Twitter</span>
                                        </v-tooltip>


                                        <!--<b>Μάθετε τα τελευταία νέα του Ευδόξου στο Twitter <a-->
                                        <!--href=" https://twitter.com/eudoxusgr"-->
                                        <!--target="_blank"><img :src="images.sample" width="18" height="18"></a>-->
                                        <!--</b>-->
                                    </p>
                                    <p class="ma-3">
                                        Επιλέξτε να λαμβάνετε ειδοποιήσεις για τις
                                        <a href="https://diavlos.grnet.gr/gdpr-newsletter-subscribe" target="_blank">ζωντανές
                                            μεταδόσεις επιστημονικών και πολιτιστικών εκδηλώσεων</a>
                                        που διενεργεί το Εθνικό Δίκτυο Υποδομών Τεχνολογίας και Έρευνας (ΕΔΥΤΕ).
                                    </p>

                                </v-card-text>
                            </v-card>
                            <v-layout align-center fill-height justify-end pa-3 row v-if="hasLibrarys">
                                <v-btn @click="getLibrarys()" color="info">Λίστα Βιβλιοθηκών</v-btn>
                            </v-layout>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <br>

                    <v-alert :value="hasBorrowedAlert" class="rounded-alert" icon="error" outline type="error">
                        {{ hasBorrowedAlertMsg }}
                    </v-alert>
                </v-flex>

            </v-layout>
        </v-container>
        <div class="text-center" max-width="500px">
            <v-dialog scrollable
                      v-model="libraryDialog">
                <v-card>
                    <v-card-title
                            class="justify-center white--text secondary">
                        <span class="headline">Βιβλιοθήκες</span>
                    </v-card-title>

                    <v-card-text>

                        <v-data-table
                                :headers="headers"
                                :items="librarys"
                                class="elevation-1"
                                hide-actions
                        >
                            <template slot="items" slot-scope="props">
                                <td>
                                    <v-icon class="">school</v-icon>
                                </td>
                                <td> {{ props.item.name }}</td>
                                <td class="text-xs-left">{{ props.item.address }}</td>
                                <td class="text-xs-right">{{ props.item.phone }}</td>
                                <td class="text-xs-left">{{ props.item.contactEmail }}</td>
                                <td class="text-xs-left">{{ props.item.openingHours }}</td>
                                <td class="text-xs-left"><a @click="openLibraryURL(props.item)">{{ props.item.url }}</a>
                                </td>
                            </template>
                        </v-data-table>

                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                                @click="libraryDialog = false"
                                color="primary"
                                text>
                            Κλείσιμο
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<script>

    import StudentCredentialsEdit from './StudentCredentialsEdit';
    import InitializationComponent from "./InitializationComponent";
    import utilities from '../../utilities';
    import MessageComponent from "../ExtraComponents/MessageComponent";
    import request from '../../requests';

    export default {
        name: "MainPage",
        data() {
            return {
                hasLibrarys: false,
                libraryDialog: false,
                librarys: [],
                utilities,
                dataEntryAllowedAlert: false,
                dataEntryAllowedAlertMsg: '',
                activeAlert: false,
                isNplus2orKatataktiriosAlert: false,
                wronglyDeliveredAlert: false,
                hasBorrowedAlert: false,
                StudentPanel: [...Array(this.items).keys()].map(_ => true),
                GeneralPanel: [...Array(this.items).keys()].map(_ => true),
                activeAlertMsg: 'Ο λογαριασμός σας έχει απενεργοποιηθεί. Δεν επιτρέπονται αλλαγές στη δήλωσή σας και δεν θα μπορείτε να παραλάβετε βιβλία από τα Σημεία Διανομής. Παρακαλώ επικοινωνήστε με το Γραφείο Αρωγής.',
                isNplus2orKatataktiriosAlertMsg: 'Βάσει της νομοθεσίας δεν δικαιούστε δωρεάν διανομής συγγραμμάτων εφόσον είστε άνω των ν+2 ετών φοίτησης ή παρακολουθείτε μαθήματα για τη λήψη τρίτου ή ανωτέρου πτυχίου προπτυχιακών σπουδών. Έχετε τη δυνατότητα να αποκτήσετε συγγράμματα μόνο μέσω της Ανταλλαγής Συγγραμμάτων (Eudoxus+).',
                wronglyDeliveredAlertMsg: 'Υπάρχει εκκρεμότητα επιστροφής συγγραμμάτων, τα οποία παραλάβατε κατ\' απόκλιση του κανονισμού διανομής τους.' +
                    'Εάν τα σημειωμένα προς επιστροφή συγγράμματα αφορούν στο <b>τρέχον</b> εξάμηνο, η επιστροφή τους θα πρέπει να γίνει στα σημεία διανομής από τα οποία τα προμηθευτήκατε.' +
                    'Διαφορετικά, η επιστροφή θα είναι εφικτή σε οποιαδήποτε από τις Ακαδημαϊκές Βιβλιοθήκες του Ιδρύματός σας, και εφόσον δεν έχετε υποβάλλει δήλωση συγγραμμάτων σε επόμενο εξάμηνο.' +
                    'Στις Γενικές Πληροφορίες μπορείτε να βρείτε την <b>Λίστα Βιβλιοθηκών</b> του Ιδρύματός σας.',
                hasBorrowedAlertMsg: 'Έχετε παραλάβει συγγράμματα με τη μορφή δανεισμού και υποχρεούστε να τα επιστρέψετε μετά την πάροδο ενός έτους στη βιβλιοθήκη του Ιδρύματος σας. ',
                studentInfo: [],
                generalInfo: [],
                dialog: false,
                images: {
                    sample: require('@/assets/banners/twitter.png')
                },
                headers: [
                    {
                        text: '',
                        align: 'left',
                        sortable: false,
                        value: ''
                    },
                    {
                        text: 'Βιβλιοθήκη',
                        align: 'left',
                        sortable: false,
                        value: 'name'
                    },
                    {text: 'Διεύθυνση', sortable: false, value: 'address'},
                    {text: 'Τηλέφωνο', sortable: false, value: 'phone'},
                    {text: 'E-Mail', sortable: false, value: 'contactEmail'},
                    {text: 'Ωράριο Λειτουργίας', sortable: false, value: 'openingHours'},
                    {text: 'Ιστοσελίδα', sortable: false, value: 'url'}
                ]
            }
        },
        components: {
            MessageComponent,
            InitializationComponent,
            StudentCredentialsEdit
        },
        methods: {
            getStudentCredentials() {
                this.studentInfo.push(
                    {name: 'Κωδικός Φοιτητή στον Εύδοξο', value: this.$store.getters.login.id},
                    {name: 'Όνομα', value: this.$store.getters.login.firstname},
                    {name: 'Επώνυμο', value: this.$store.getters.login.lastname},
                    {name: 'Αριθμός Μητρώου', value: this.$store.getters.login.am},
                    {name: 'Ίδρυμα', value: this.$store.getters.login.secretariat.secretaryAcademic.institution},
                    {name: 'Σχολή', value: this.$store.getters.login.secretariat.secretaryAcademic.school},
                    {name: 'Τμήμα', value: this.$store.getters.login.secretariat.secretaryAcademic.department},
                    {name: 'Τρέχον Εξάμηνο', value: this.$store.getters.login.currentSemester},
                    {name: 'Αριθμός Κινητού Τηλεφώνου', value: this.$store.getters.login.mobile},
                    {name: 'E-mail Επικοινωνίας', value: this.$store.getters.login.personalEmail},

                    {
                        name: 'Αριθμός Μαθημάτων για τα οποία έχετε ήδη παραλάβει συγγράμματα πριν το σύστημα Εύδοξος',
                        value: this.$store.getters.login.courseCountBeforeEudoxos
                    },
                );

                this.generalInfo.push(
                    {
                        name: 'Περίοδος Υποβολής Δηλώσεων',
                        value: this.$store.getters.login.statementDataEntryValidDate.startDate
                            + ' - ' + this.$store.getters.login.statementDataEntryValidDate.endDate,
                        hasFlagBooks: false
                    });
                for (var i = 0; i < this.$store.getters.login.distributionDataEntryValidDates.length; i++) {
                    let date = this.$store.getters.login.distributionDataEntryValidDates[i];
                    if (date.resourceType === 'Book_Delivery') {
                        this.generalInfo.push({
                            name: 'Προθεσμία Παραλαβής Συγγραμμάτων',
                            value: this.$store.getters.login.distributionDataEntryValidDates[i].endDate,
                            hasFlagBooks: false
                        })
                    }
                }
                if (this.studentInfo[10].value == 0) {
                    this.studentInfo.splice(10, 1);
                }
            },
            changeCredentials() {
                this.studentInfo[7].value = this.$store.getters.login.currentSemester;
                this.studentInfo[8].value = this.$store.getters.login.mobile;
                this.studentInfo[9].value = this.$store.getters.login.personalEmail;
                this.studentInfo[10].value = this.$store.getters.login.courseCountBeforeEudoxos;
            },
            checkIfAlertIsVisible() {
                var login = this.$store.getters.login;
                var tooltipBookId = this.$store.getters.tooltipBookId;
                for (var bookId in tooltipBookId) {
                    if (tooltipBookId[bookId].book.wronglyDelivered &&
                        tooltipBookId[bookId].book.delivered && tooltipBookId[bookId].book.status.status == 'DELIVERED') {
                        this.wronglyDeliveredAlert = true
                    }
                    if (tooltipBookId[bookId].book.wronglyDelivered || (tooltipBookId[bookId].book.borrowed &&
                        tooltipBookId[bookId].book.delivered && tooltipBookId[bookId].book.status.status == 'DELIVERED')) {
                        this.hasLibrarys = true
                    }
                    if (tooltipBookId[bookId].book.borrowed &&
                        tooltipBookId[bookId].book.delivered && tooltipBookId[bookId].book.status.status == 'DELIVERED') {
                        this.hasBorrowedAlert = true
                    }
                }
                if (!this.$store.getters.login.active)
                    this.activeAlert = true;

                if (utilities.isNPlus2OrKatataktirios()) {
                    this.isNplus2orKatataktiriosAlert = true;
                    this.$store.commit('setCheckedDegree', false);
                } else {
                    this.$store.commit('setCheckedDegree', true);
                }


                if (this.$store.getters.login.pendingEvaluation && !this.$store.getters.pendingEvaluationShow) {
                    this.$store.commit('setPendingEvaluationShow', true);
                    var setMessageObject = {};
                    setMessageObject.title = 'Έρευνα Διανομής Συγγραμμάτων';
                    setMessageObject.message = 'Πριν συμπληρώσετε τη δήλωσή σας, μπορείτε να συμπληρώσετε το ερωτηματολόγιο για την Έρευνα αποτίμησης της χρήσης των Συγγραμμάτων που έχετε παραλάβει';
                    setMessageObject.agree = true;
                    setMessageObject.close = true;
                    this.$store.commit('setMessageObject', setMessageObject);
                    this.$store.commit('setMessageModal', true);
                }
                var today = new Date();
                var dd = String(today.getDate()).padStart(2, '0');
                var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                var yyyy = today.getFullYear();

                today = mm + '/' + dd + '/' + yyyy;

                var startDate = this.formatDate(login.statementDataEntryValidDate.startDate);
                var endDate = this.formatDate(login.statementDataEntryValidDate.endDate);

                if (this.$store.getters.active.dataEntryAllowed == false) {
                    if (Date.parse(today) <= startDate) {
                        this.dataEntryAllowedAlert = true;
                        this.dataEntryAllowedAlertMsg = 'Η δήλωση συγγραμμάτων για το τρέχον εξάμηνο θα είναι διαθέσιμη από τις ' + login.statementDataEntryValidDate.startDate + ' π.μ'
                    } else if (Date.parse(today) > endDate) {
                        this.dataEntryAllowedAlert = true;
                        this.dataEntryAllowedAlertMsg = 'Η δήλωση συγγραμμάτων για το τρέχον εξάμηνο έχει λήξει '
                    }
                }
                else {
                    if (Date.parse(today) == startDate) {
                        this.dataEntryAllowedAlert = true;
                        this.dataEntryAllowedAlertMsg = 'Η δήλωση συγγραμμάτων για το τρέχον εξάμηνο θα είναι διαθέσιμη από τις ' + login.statementDataEntryValidDate.startDate + '  π.μ'
                    }
                }
            },
            formatDate(date) {
                var onlyDate = date.split(' ');
                var [day, month, year] = onlyDate[0].split('/');
                return Date.parse(`${month}/${day}/${year}`);
            },
            getLibrarys() {
                this.$store.commit('setLoadingModal', true);
                request.getLibrary(this.$store.getters.login.id, this.successGetLibrary)
            },
            successGetLibrary(response) {
                this.librarys = [];
                for (var i = 0; i < response.length; i++) {
                    var library = {
                        name: response[i].name,
                        address: response[i].address,
                        phone: response[i].phone,
                        contactEmail: response[i].contactEmail,
                        openingHours: response[i].openingHours,
                        url: response[i].url
                    };
                    this.librarys.push(library);
                }
                this.$store.commit('setLoadingModal', false);
                this.libraryDialog = true;
            },
            openLibraryURL(library) {

                if (!library.url.match(/^https?:\/\//i)) {
                    library.url = 'http://' + library.url;
                }
                window.open(library.url, "_blank");
            },
            openStudentEvaluation() {
                var link = 'https://service.eudoxus.gr/public/book/student/evaluation/' + this.$store.getters.login.encryptedId;
                window.open(link, "_blank");
            }
        },
        computed: {
            email: function () {
                return this.$store.getters.login.personalEmail
            },
            mobile: function () {
                return this.$store.getters.login.mobile
            }
        },
        created() {
            this.getStudentCredentials();
            this.checkIfAlertIsVisible();
        },
        mounted() {
            utilities.removeDatatableLoadingElement();
        },
    }
</script>

<style scoped>

</style>
